module.exports = __webpack_public_path__ + "img/fuwu_03.31e23a2d.png";